export default (state = {}, action) => {
  switch (action.type) {
    case "GET_PLANS":
      return { ...state, plans: action.plans };
    case "GET_SUBSCRIPTIONS":
      return { ...state, subscriptions: action.subscriptions };
    default:
      return state;
  }
};
